module.exports = __webpack_public_path__ + "img/maintain.6b667675.png";